import React, { useState } from "react";

interface AddAddressModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (form: {
        name: string;
        phone: string;
        province: string;
        district: string;
        ward: string;
        address: string;
        isDefault: boolean;
    }) => void;
}

export default function AddAddressModal({ open, onClose, onSave }: AddAddressModalProps) {
    const [isActive, setActive] = useState(false);
    const [form, setForm] = useState({
        name: "",
        phone: "",
        province: "",
        district: "",
        ward: "",
        address: "",
        isDefault: false,
    });

    if (!open) return null;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        const checked = 'checked' in e.target ? e.target.checked : false;
        setForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log("Submit form:", form);
    };

    return (
        <div
            role="presentation"
            className="styles_modalItem__YKbSY"
            style={{ position: "fixed", inset: 0, zIndex: 1300 }}
        >
            {/* backdrop */}
            <div
                aria-hidden="true"
                style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,.5)",
                }}
                onClick={onClose}
            />

            <div
                className="styles_auth_modal_content_checkout__UhpEG"
                style={{ width: 580, margin: "60px auto" }}
            >
                <header className="styles_auth_modal_title__tQ0WQ">
                    Thêm địa chỉ nhận hàng
                </header>

                {/* FORM */}
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        onSave(form);
                        onClose();
                    }}
                >
                    <div className="MuiGrid-root styles_formGrid__bgm3n MuiGrid-container">

                        {/* Họ tên + SĐT */}
                        <div className="MuiGrid-root styles_formGridFieldName___9PUk MuiGrid-item MuiGrid-grid-xs-12">
                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl">
                                    <input
                                        name="name"
                                        placeholder="Họ và tên khách hàng*"
                                        type="text"
                                        value={form.name}
                                        onChange={handleChange}
                                        className="MuiInputBase-input MuiOutlinedInput-input"
                                    />
                                </div>
                            </div>

                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl">
                                    <input
                                        name="phone"
                                        placeholder="Số điện thoại*"
                                        type="text"
                                        value={form.phone}
                                        onChange={handleChange}
                                        className="MuiInputBase-input MuiOutlinedInput-input"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Province / District / Ward */}
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                            <div style={{ margin: "auto" }}>
                                <div className="MuiGrid-root styles_container__jpKDg MuiGrid-container">

                                    {/* Province */}
                                    <div className="MuiGrid-root styles_addressWrapper__kN0xP MuiGrid-item MuiGrid-grid-xs-12">
                                        <div className="MuiFormControl-root MuiTextField-root styles_select__oxdi5">
                                            <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                                <select
                                                    name="province"
                                                    value={form.province}
                                                    onChange={handleChange}
                                                    className="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                                                >
                                                    <option value="0">Tỉnh/Thành phố</option>
                                                    <option value="01">Thành phố Hà Nội</option>
                                                    <option value="79">Thành phố Hồ Chí Minh</option>
                                                    <option value="48">Thành phố Đà Nẵng</option>
                                                    {/* ... bạn có thể giữ nguyên list như HTML */}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* District */}
                                    <div className="MuiGrid-root styles_addressWrapper__kN0xP MuiGrid-item MuiGrid-grid-xs-12">
                                        <div className="MuiGrid-root MuiGrid-grid-sm-6">
                                            <div className="MuiFormControl-root MuiTextField-root styles_select__oxdi5">
                                                <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                                    <select
                                                        name="district"
                                                        value={form.district}
                                                        onChange={handleChange}
                                                        className="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                                                    >
                                                        <option value="0">Quận/Huyện</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Ward */}
                                        <div className="MuiGrid-root MuiGrid-grid-sm-6">
                                            <div className="MuiFormControl-root MuiTextField-root styles_select__oxdi5">
                                                <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                                    <select
                                                        name="ward"
                                                        value={form.ward}
                                                        onChange={handleChange}
                                                        disabled={false}
                                                        className="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                                                    >
                                                        <option value="0">Phường/Xã</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Address */}
                        <div className="MuiGrid-root styles_formGridFieldName___9PUk MuiGrid-item MuiGrid-grid-xs-12">
                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl">
                                    <input
                                        name="address"
                                        placeholder="Địa chỉ nhà thuốc/phòng khám"
                                        type="text"
                                        value={form.address}
                                        onChange={handleChange}
                                        className="MuiInputBase-input MuiOutlinedInput-input"
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                            style={{ color: "rgb(121, 121, 121)" }}
                        >
                            <p className="MuiTypography-root MuiTypography-body1">
                                <label className="MuiFormControlLabel-root" onClick={() => setActive(prev => !prev)}>
                                    <span
                                        className={
                                            "MuiButtonBase-root MuiIconButton-root jss1 MuiCheckbox-root styles_checkbox___9JzD MuiCheckbox-colorSecondary MuiIconButton-colorSecondary " +
                                            (isActive ? "jss2 Mui-checked" : "")
                                        }
                                    >
                                        <span className="MuiIconButton-label">
                                            <input
                                                className="jss4 pointer-events-none"
                                                name="isDefault"
                                                type="checkbox"
                                                data-indeterminate="false"
                                                value="false"
                                                onClick={e => e.stopPropagation()}
                                                checked={isActive}
                                                readOnly
                                            />
                                            {isActive ? (
                                                <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                                </svg>
                                            ) :
                                                <svg
                                                    className="MuiSvgIcon-root"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                                                </svg>
                                            }

                                        </span>
                                        <span className="MuiTouchRipple-root"></span>
                                    </span>

                                    <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                        Đặt làm địa chỉ mặc định
                                    </span>
                                </label>
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                            <div className="styles_btnBox__zQz8x">
                                <button onClick={onClose} type="button" className="styles_btn_cancel__WiBEo">
                                    Hủy bỏ
                                </button>

                                <button type="submit" className="styles_btn_register__qgw1K">
                                    Xác nhận
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}